import React from 'react';
import classnames from 'classnames';
import { map, noop } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Tooltip } from 'modules/tooltip';

// mood icon names based on option name
const MOOD_ICONS = {
    angry: 'faceAngry',
    sad: 'faceSad',
    neutral: 'faceNeutral',
    happy: 'faceHappy',
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { moodInput as MoodInput } from 'ui/views/generic/moodInput';
 *
 * // render
 * <MoodInput propName='propValue'/>
 */
export const moodInput = ( props ) => {
    return (
        <div className='ui-mood-input'>

            {/* title */}
            <div className='ui-mood-input__title'>
                { getLabel( 'displayTextMood' ) } -
            </div>

            {/* options */}
            <div className='ui-mood-input__options'>
                {
                    map( props.options, option => {

                        // item class name
                        const itemClassName = classnames( 'ui-mood-input__options__item', {
                            'ui-mood-input__options__item--active': props.value === option.value,
                        } );

                        return (
                            <Tooltip
                                key={ option.name }
                                title={ getLabel( 'displayTextMood' ) }
                                text={ getLabel( option.title ) }
                                render={ ( binding = {} ) => (
                                    <div
                                        { ...binding }
                                        className={ itemClassName }
                                        onClick={ () => props.onChange( option.value ) }
                                    >
                                        <Icon name={ MOOD_ICONS[ option.name ] } />
                                    </div>
                                ) }
                            />
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
moodInput.displayName = 'moodInput';

// set default props
moodInput.defaultProps = {
    options: [],
    value: null,
    onChange: noop,
};

// prop types
moodInput.propTypes = {};
